module.exports = __webpack_public_path__ + "static/cosmos-0bf6a9174a824d2ee1e489be284f2d2c.jpg";